// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQElT7i4oZ0iY5bN-GikQZzmZDaAWev08",
  authDomain: "grantmagicbeta.firebaseapp.com",
  projectId: "grantmagicbeta",
  storageBucket: "grantmagicbeta.appspot.com",
  messagingSenderId: "11959815243",
  appId: "1:11959815243:web:9fb759df8cf172d21851ce",
  measurementId: "G-K62Z9FX93R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export default db; // This line exports the Firestore instance as the default export
export { auth };